import React from "react";

import { cn } from "../../../services/common/className";

import "./agingItemTitle.scss";

export interface AgingItemTitleProps {
  mods?: {};
}

const AgingItemTitle: React.FC<AgingItemTitleProps> = (props) => {
  return (
    <div
      className={cn("xgs-aging-item__title")(props.mods)}
    >
      {props.children}
    </div>
  );
};

export default AgingItemTitle;
